const trimTrailingSlash = (value) => String(value || "").replace(/\/+$/, "");
const trimLeadingSlash = (value) => String(value || "").replace(/^\/+/, "");
const normalizePath = (value) => {
  const clean = String(value || "").trim();
  if (!clean) return "";
  return `/${trimLeadingSlash(clean).replace(/\/+$/, "")}`;
};

const readEnv = (key, fallback = "") => {
  const value = process.env[key];
  return value === undefined || value === null || value === "" ? fallback : value;
};

const readPositiveNumberEnv = (key, fallback) => {
  const value = Number(process.env[key]);
  return Number.isFinite(value) && value > 0 ? value : fallback;
};

export const env = {
  appName: readEnv("REACT_APP_APP_NAME", "Sama.IOT"),
  appVersion: readEnv("REACT_APP_APP_VERSION", "2.0"),
  baseDomain: trimTrailingSlash(readEnv("REACT_APP_BASE_DOMAIN", "http://localhost")),
  baseDomainProd: trimTrailingSlash(
    readEnv("REACT_APP_BASE_DOMAIN_PROD", "https://sama-tech.ae")
  ),
  // apiPort: readEnv("REACT_APP_API_PORT", "5001"),
  basePath: normalizePath(readEnv("REACT_APP_BASE_PATH", "/iot")),
  stripePublicKey: readEnv("REACT_APP_STRIPE_PUBLIC_KEY", ""),
  sensorsBaseUrl: trimTrailingSlash(readEnv("REACT_APP_SENSORS_BASE_URL", "")),
  otaBaseUrl: trimTrailingSlash(readEnv("REACT_APP_OTA_BASE_URL", "")),
  bucketDevices: readEnv("REACT_APP_BUCKET_DEVICES", "Sensors"),
  defaultIcon: readEnv("REACT_APP_DEFAULT_ICON", "default-image.svg"),
  defaultDatastreamIcon: readEnv("REACT_APP_DEFAULT_DATASTREAM_ICON", "datastream.svg"),
  defaultShipmentIcon: readEnv("REACT_APP_DEFAULT_SHIPMENT_ICON", "shipping.svg"),
  defaultDeviceCodeIcon: readEnv("REACT_APP_DEFAULT_DEVICE_CODE_ICON", "device-code.png"),
  aiVoiceSessionTtlMinutes: readPositiveNumberEnv(
    "REACT_APP_AI_VOICE_SESSION_TTL_MINUTES",
    15
  ),
};

const buildBaseUrl = () => {
  const portSuffix = env.apiPort ? `:${env.apiPort}` : "";
  return `${env.baseDomain}${portSuffix}${env.basePath}`;
};

export const APP_NAME = env.appName;
export const APP_VERSION = env.appVersion;
export const BASE_DOMAIN = env.baseDomain;
export const BASE_DOMAIN_PROD = env.baseDomainProd;
export const STRIPE_PUBLIC_KEY = env.stripePublicKey;
export const BASE_URL = trimTrailingSlash(readEnv("REACT_APP_BASE_URL", buildBaseUrl()));
export const BASE_URL_API = trimTrailingSlash(
  readEnv("REACT_APP_BASE_URL_API", `${BASE_URL}/api-v1`)
);
export const AI_VOICE_PROCESS_URL = readEnv(
  "REACT_APP_AI_VOICE_PROCESS_URL",
  `${BASE_URL_API}/ai-voice/process`
);
export const AI_VOICE_BEARER_TOKEN = readEnv(
  "REACT_AI_VOICE_BEARER_TOKEN",
  `${BASE_URL_API}/ai-voice/process`
);
export const AI_VOICE_SESSION_TTL_MINUTES = env.aiVoiceSessionTtlMinutes;
export const STATIC_FILES = `${BASE_URL}/static/files/`;
export const STATIC_ICONS = `${BASE_URL}/static/files/icons/`;
export const SENSORS_URL =
  env.sensorsBaseUrl || `${env.baseDomainProd}/center`;
export const OTA_URL = env.otaBaseUrl || `${env.baseDomain}/test-ota`;
export const BUCKET_DEVICES = env.bucketDevices;
export const defaultIcon = env.defaultIcon;
export const defaultDatastreamIcon = env.defaultDatastreamIcon;
export const defaultShipmentIcon = env.defaultShipmentIcon;
export const defaultDeviceCodeIcon = env.defaultDeviceCodeIcon;
